import { useLocation } from 'react-router-dom'

const pathMap = [
  { path: '/login', label: 'Login' },
  { path: '/users', label: 'Utenti' }
]

export const usePageTitle = () => {
  useLocation()
  if (window.location.pathname === '/') return 'Home'

  const matchTitle = ({ path }) => path === window.location.pathname

  return pathMap.find(matchTitle)?.label || 'Home'
}

export const useMenuItems = (username) => ([
  { label: 'Riconcilia Carte', icon: 'xls-2', path: '/' },
  { label: 'VivaWallet Zucchetti', icon: 'notes', path: 'zucchetti' },
  { label: 'Logout', icon: 'primeicon pi-power-off', path: 'logout' }
].filter(Boolean))
